import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
    LOGIN_FINISH,
    LOGOUT_FINISH,
    LoginFinishAction,
    LogoutFinishAction,
    SESSION_TIMEOUT_CUSTOM_LOGOUT_HOOK,
    SessionTimeoutCustomLogoutAction,
    MFA_CUSTOM_LOCKOUT_HOOK,
    MfaCustomLockoutHookAction,
    FEDERATED_ONLY_LOGIN_FAILED,
    FederatedOnlyLoginFailedAction,
    AUTH_SUCCESS_NOTIFICATION,
    AUTH_FAILURE_NOTIFICATION,
    AuthSuccessNotificationAction,
    AuthFailureNotificationAction,
} from 'ngpd-merceros-authentication-fe-components';
import { tap } from 'rxjs/operators';

import { AuthHookService } from './auth-hook.service';

@Injectable()
export class AuthHookEffects {
    authLoginFinishHook$ = createEffect(
        () =>
            this._actions$.pipe(
                ofType<LoginFinishAction>(LOGIN_FINISH),
                tap(() => this._authHookService.postLogin())
            ),
        { dispatch: false }
    );

    authLogoutFinishHook$ = createEffect(
        () =>
            this._actions$.pipe(
                ofType<LogoutFinishAction>(LOGOUT_FINISH),
                tap(() => {
                    this._authHookService.postLogout();
                })
            ),
        { dispatch: false }
    );

    authSessionTimeoutCustomHook$ = createEffect(
        () =>
            this._actions$.pipe(
                ofType<SessionTimeoutCustomLogoutAction>(SESSION_TIMEOUT_CUSTOM_LOGOUT_HOOK),
                tap(() => {
                    // need to set common config customSessionTimeoutLogout to true and need to do reroute here
                })
            ),
        { dispatch: false }
    );

    authMfaCustomLockoutHook$ = createEffect(
        () =>
            this._actions$.pipe(
                ofType<MfaCustomLockoutHookAction>(MFA_CUSTOM_LOCKOUT_HOOK),
                tap((res) => this._authHookService.customMfaLockout(res.payload))
            ),
        { dispatch: false }
    );

    authFederatedOnlyLoginFailedHook$ = createEffect(
        () =>
            this._actions$.pipe(
                ofType<FederatedOnlyLoginFailedAction>(FEDERATED_ONLY_LOGIN_FAILED),
                tap(() => this._authHookService.federatedOnlyLoginFail())
            ),
        { dispatch: false }
    );

    authSuccessNotification$ = createEffect(
        () =>
            this._actions$.pipe(
                ofType<AuthSuccessNotificationAction>(AUTH_SUCCESS_NOTIFICATION),

                tap((action) => this._authHookService.successToast(action.payload))
            ),
        { dispatch: false }
    );

    authFailureNotification$ = createEffect(
        () =>
            this._actions$.pipe(
                ofType<AuthFailureNotificationAction>(AUTH_FAILURE_NOTIFICATION),
                tap((action) => this._authHookService.failureToast(action.payload))
            ),
        { dispatch: false }
    );

    /**
     *
     * @param _actions$
     * @param _authHookService
     */
    constructor(
        private _actions$: Actions,
        private _authHookService: AuthHookService
    ) {}
}
